export default __webpack_public_path__ + "static/media/CarlosQProFP.76c0f0f1.jpg";